import { useEffect, useState } from "react";
import { _LoanLine } from "../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { BasicMultiSelectTable } from "../../../theme/Component/BasicMultiSelecTable";
import { PrintJson } from "../../../theme/Component/PrintJson";


export interface LoanLineMultiSelectResult {
    IDList: number[];
    ListItems: any[];
}

export interface LoanLineSingleSelectResult {
    IDLoanLine: number;
    Name: string;
}

interface BaseProps {
    label?: string;
    renderLoan?: string;
    IDSelect?: number | number[];
}

interface MultiSelectProps extends BaseProps {
    multiSelect: true;
    onChange: (value: LoanLineMultiSelectResult) => void;
}

interface SingleSelectProps extends BaseProps {
    multiSelect?: false;
    onChange: (value: LoanLineSingleSelectResult) => void;
}

type Props = MultiSelectProps | SingleSelectProps;


export const LoanLineEditor = ({ label, onChange, renderLoan, multiSelect }: Props) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_LoanLine);

    const [valor, setValor] = useState<string>("");
    const [idAccount, setIDAccount] = useState<number>(NaN);

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        setValor(renderLoan)
    }, [renderLoan])

    useEffect(() => {
        getLista();
    }, [])

    const returnData = () => {
        if (multiSelect) {
            if (!listaResult || listaResult.length === 0) {
                (onChange as (value: LoanLineMultiSelectResult | null) => void)({
                    IDList: null,
                    ListItems: null
                });
                setValor("")
                setModal({ ...modal, view: false });
            } else {
                const nombres = listaResult.map(item => item.DataBeanProperties.Name).join(", ");
                setValor(nombres);

                const ids = listaResult.map(item => item.DataBeanProperties.IDLoanLine);
                const items = listaResult.map(item => item.DataBeanProperties);

                (onChange as (value: LoanLineMultiSelectResult) => void)({
                    IDList: ids,
                    ListItems: items
                });

                setModal({ ...modal, view: false });
            }
        } else {
            if (!bean.IDLoanLine) {
                toast.error("Linea de Credito no valida");
            } else {
                setValor(`${bean.IDLoanLine} - ${bean.Name}`);

                (onChange as (value: LoanLineSingleSelectResult) => void)(bean);

                setModal({ ...modal, view: false });
            }
        }
    };

    const getLista = () => {
        instance.getLoanLineCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    // console.log(resp)
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDLoanLine', visible: true },
        { title: 'Prefijo Línea de Crédito', property: 'LoanNumberPrefix', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        // { title: 'Código', property: 'Code', visible: true },
        // { title: 'Orden en Lista', property: 'RowOrder', visible: true },
        // { title: 'Habilitado', property: 'Enabled', visible: true },
        // { title: 'Requiere codeudor', property: 'RequiresCodebtor', visible: true },
        // { title: 'Mínimo de Cuotas', property: 'MinQuotas', visible: true },
        // { title: 'Máximo de Cuotas', property: 'MaxQuotas', visible: true },
        // { title: 'Habilitar Destino a Analista', property: 'EnableLoanDestination', visible: true },
        // { title: 'Mínimo Tiempo Servicio', property: 'MinimumServiceTime', visible: true },
        // { title: 'Mínimo Valor de Crédito', property: 'MinimumLoanAmount', visible: true, mask: MASK_MONEY },
        // { title: 'Máximo Valor de Crédito', property: 'MaximumLoanAmount', visible: true, mask: MASK_MONEY },
        { title: 'Interes Corriente', property: 'CurrentPercentInterest', visible: true },
        { title: 'Interes por Mora', property: 'ExpiredPercentInterest', visible: true },
        // { title: 'Porcentaje del Saldo Base para Habilitar Refinanciación', property: 'LeftPercentForRefinancing', visible: true },
        // { title: 'Plazo Base para Habilitar Refinanciación', property: 'LeftTimeForRefinancing', visible: true },
        // { title: 'Organización', property: 'IDCompany', visible: true },
        // { title: 'Proceso BPM para crédito', property: 'BusinessProcessName', visible: true },
        // { title: 'Destino Crédito', property: 'LoanDestinationName', visible: true },
        // { title: 'Tipo de Amortización', property: 'AmortizationTypeName', visible: true },
        // { title: 'Tipo de Moneda', property: 'IDLoanCurrency', visible: true },
        // { title: 'Es Crédito de Tercero Administrado', property: 'IsThirdLoan', visible: true },
        // { title: 'Tercero Administrado', property: 'IDThirdLoanEntity', visible: true },
        // { title: 'Configuración Contable Crédito Normal', property: 'LoanAccountantConceptForCurrentName', visible: true },
        // { title: 'Configuración Contable Crédito Difícil Cobro', property: 'LoanAccountantConceptForDefeatName', visible: true },
        // { title: 'Configuración Plazo Línea', property: 'IDLoanTimeTerm', visible: true },
        // { title: 'Configuración Tipo Plazo Cuota', property: 'IDQuotaTimeTerm', visible: true },

    ]

    const [listaResult, setListaResult] = useState<any>([]);
    const clearSelection = () => {
        setValor("");

        if (multiSelect) {
            (onChange as (value: LoanLineMultiSelectResult | null) => void)(null);
            setListaResult([]);
        } else {
            (onChange as (value: LoanLineSingleSelectResult | null) => void)(null as any);
            setBean({});
        }
    };


    return (
        <>
            <label>{label ?? "Linea de Credito"}</label>
            <div
                className="form-control d-flex justify-content-between align-items-center"
                style={{ minHeight: '35px', cursor: "pointer" }}
                onClick={() => setModal({ ...modal, view: true })}
            >
                {valor ? (
                    <>
                        <span>{valor}</span>
                        <button
                            type="button"
                            className="btn btn-sm btn-link text-danger"
                            style={{ textDecoration: "none" }}
                            onClick={(e) => {
                                e.stopPropagation(); // evita que abra el modal
                                clearSelection();
                            }}
                        >
                            ✕
                        </button>
                    </>
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={() => { returnData() }}>
                <div className="row">
                    <div className="col-md-12">
                        {multiSelect ?
                            <BasicMultiSelectTable clearnotListBody body={lista} bodyResult={listaResult} head={head} keyId="IDLoanLine" updateValues={({ bodyResult }) => { setListaResult(bodyResult) }} />
                            :
                            <BasicTable body={lista} head={head} rowSet={setBean} />
                        }
                    </div>
                </div>
            </Modal>
        </>
    )
}